import {HTTP} from '@/CallAPI'
export default {
  login (user) {
    return HTTP.post('login', user)
  },

  logout () {
    return HTTP.post('logout')
  },

  getProfile () {
    return HTTP.get('profiles')
  },

  updateProfile (user) {
    return HTTP.post('profiles', user)
  },

  changePassword (password) {
    return HTTP.post('profiles/change-password', password)
  }
}



// WEBPACK FOOTER //
// ./src/service/profile.js